export default "__VITE_ASSET__C3ZvTJ6F__"